
import Marionette from "../../shared/marionette-mustache";
import {autoinject} from "aurelia-dependency-injection";
import {backboneViewProperties} from "../../decorators/backbone-properties";
import {AppEvents} from "../../app-events";
import {BrowseModel} from "../models/browse";
import {BrowsePanelsCollection} from "../collections/browse-panels";
import {IRequestOptions} from "../../search/interfaces/request-options";

const template = require<string>("../../old-browse/views/browse.html");
const dom = {
   BROWSE_LINKS : ".browse-link",
   BROWSE_TABS : ".browse-tab",
   BROWSE_SEARCH: "#browseSearch",
   BROWSE_CLEAR: "#browseClear",
   BROWSE_SCROLL_LEFT: "#browse-scroller-left-icon",
   BROWSE_SCROLL_RIGHT: "#browse-scroller-right-icon",
   BROWSE_PANELS: ".browse-panels",
   BROWSE_BREADCRUMB: "#browse-breadcrumb",
   BROWSE_BREADCRUMB_CONTAINER: ".browse-breadcrumb-container",
   BROWSE_BREADCRUMB_OUTER_CONTAINER: ".browse-breadcrumb-outer-container",
   BROWSE_BREADCRUMB_SCROLL_LEFT: ".breadcrumb-left-arrow",
   BROWSE_BREADCRUMB_SCROLL_RIGHT: ".breadcrumb-right-arrow",
};

const breadcrumbMargin = 10;
const breadcrumbPadding = 8;
const searchButtonPadding = 30;
const clearButtonPadding = 15;

@autoinject
@backboneViewProperties({
    template: template
})
export class BrowseView extends Marionette.LayoutView<BrowseModel> {

    private panelsView: BrowsePanelsCollection;
    private panelsRegion: Marionette.Region;

    constructor(
        private appEvents: Backbone.Events,
        public model: BrowseModel) {
        super();
        this.$el = $(this.el);
        this.setupModelListeners();
    }

    public onShow() {
        this.setupPanels();
        this.setMaxPanels();
        this.enableBreadcrumbScrolling();
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click " + dom.BROWSE_TABS] = (e) => this.browseTabClick(e);
        events["click " + dom.BROWSE_SEARCH] = (e) => this.browseSearch(e);
        events["click " + dom.BROWSE_CLEAR] = (e) => this.browseClear(e);
        events["click " + dom.BROWSE_SCROLL_LEFT] = () => this.browseScrollLeft();
        events["click " + dom.BROWSE_SCROLL_RIGHT] = () => this.browseScrollRight();
        return events;
    }

    public regions(): any {
        const regions: any = {
            panelsRegion: ".browse-panels",
        };
        return regions;
    }

    public panelsChanged() {
        const $breadcrumb = this.$(dom.BROWSE_BREADCRUMB);
        $breadcrumb.empty();
        if (this.$(dom.BROWSE_LINKS).hasClass("active")) {
            this.model.Panels.each((panel) => {
                if (panel.Value) {
                    const text = panel.ListItems.where({Id: panel.Value.toString()})[0].get("Title");
                    const $element = $(`<li><a>${text} <b class="caret" aria-hidden="true"></b></a></li>`);
                    $breadcrumb.append($element);
                    this.appEvents.trigger(AppEvents.AppInsightsBrowsePanelLinkClick, {PanelName: text, PanelType: panel.SelectedType});
                }
            });
        }
        this.setBreadcrumbContainerSize();
        this.showOrHideButtons();
        this.scrollToRecentBreadcrumbs();
    }

    private setupPanels() {
        if (!this.panelsView) {
            this.panelsView = new BrowsePanelsCollection({ collection: this.model.Panels});
            this.panelsRegion.show(this.panelsView);
        }
    }

    private setupModelListeners() {
        this.listenTo(this.model.Panels, "change", this.panelsChanged);
        this.listenTo(this.model, "change:PanelsShiftValue", this.panelsShiftValueChanged);

        this.appEvents.on(AppEvents.WindowResized, () => { this.setMaxPanels(); this.panelsChanged(); });
    }

    private browseSearch(e: JQueryMouseEventObject) {
        let searchString = "";

        this.model.Panels.each((panel) => {
            if (panel.Value) {
                const text = panel.ListItems.where({Id: panel.Value.toString()})[0].get("Title");
                searchString = "CategoryExact[\"" + text + "\"]";
            }
        });

        const options: IRequestOptions = {
            page: 1,
            query: searchString,
            order: "Relevance",
            materialTypes: [],
            includedCategoryFilters: [],
            includedProductFilters: null
        };

        this.appEvents.trigger(AppEvents.AppInsightsBrowseFindCases, {query: options.query});
        this.appEvents.trigger(AppEvents.ResetSearch);
        this.appEvents.trigger(AppEvents.SearchRequest, options);
    }

    private browseClear(e: JQueryMouseEventObject) {
        const $breadcrumb = this.$(dom.BROWSE_BREADCRUMB);
        $breadcrumb.empty();

        this.$(dom.BROWSE_SEARCH).hide();

        this.$(dom.BROWSE_LINKS).removeClass("active");
        this.model.Panels.remove(this.model.Panels.rest(0));

        Backbone.history.navigate("browse", {trigger: true});
    }

    private browseTabClick(e: JQueryMouseEventObject) {
        e.preventDefault();
        const url = $(e.currentTarget).attr("href");
        Backbone.history.navigate(url, {trigger: true});
    }

    private showOrHideButtons() {
        if (this.$(dom.BROWSE_LINKS).hasClass("active")) {
                this.positionSearchButton();
                this.$(dom.BROWSE_SEARCH).show();
                this.positionClearButton();
                this.$(dom.BROWSE_CLEAR).show();
        }
        else {
            this.$(dom.BROWSE_SEARCH).hide();
            this.$(dom.BROWSE_CLEAR).hide();
        }
    }

    private setBreadcrumbContainerSize() {
        const extraPadding = breadcrumbMargin + breadcrumbPadding + searchButtonPadding + clearButtonPadding;
        this.$(dom.BROWSE_BREADCRUMB_OUTER_CONTAINER).width(this.$el.width() - this.$(dom.BROWSE_SEARCH).outerWidth() - this.$(dom.BROWSE_CLEAR).outerWidth() - extraPadding);
    }

    private scrollToRecentBreadcrumbs() {
        if (this.breadcrumbRequiresScrolling()) {
            this.scrollBreadcrumbsRight();
        } else {
            this.$(dom.BROWSE_BREADCRUMB).css("left", "0px");
            this.hideBreadcrumbScrollers();
        }
    }

    private breadcrumbRequiresScrolling(): boolean {
        const breadcrumbWidth = this.$(dom.BROWSE_BREADCRUMB).width();
        const searchButtonWidth = this.$(dom.BROWSE_SEARCH).outerWidth();
        const clearButtonWidth = this.$(dom.BROWSE_CLEAR).outerWidth();
        const extraPadding = breadcrumbMargin + breadcrumbPadding + searchButtonPadding + clearButtonPadding;

        return breadcrumbWidth > (this.$el.width() - searchButtonWidth - clearButtonWidth - extraPadding);
    }

    private positionSearchButton() {
        let rightPosition = 70;

        if (!this.breadcrumbRequiresScrolling()) {
            const breadcrumbWidth = this.$(dom.BROWSE_BREADCRUMB).width();
            const searchButtonWidth = this.$(dom.BROWSE_SEARCH).outerWidth();
            const extraPadding = breadcrumbMargin + breadcrumbPadding + searchButtonPadding;
            rightPosition = this.$el.width() - breadcrumbWidth - searchButtonWidth  - extraPadding;
        }

        this.$(dom.BROWSE_SEARCH).css("right", rightPosition + "px");
    }

    private positionClearButton() {
        this.$(dom.BROWSE_CLEAR).css("right", "15px");
    }

    private enableBreadcrumbScrolling() {
        let leftActivityTimer;
        let rightActivityTimer;
        const $rightArrow = this.$(dom.BROWSE_BREADCRUMB_SCROLL_RIGHT);
        const $leftArrow = this.$(dom.BROWSE_BREADCRUMB_SCROLL_LEFT);
        $leftArrow.hide().off("click mouseenter mouseleave");
        $rightArrow.hide().off("click mouseenter mouseleave");
        $rightArrow.on("click", () => this.scrollBreadcrumbsRight());
        $leftArrow.on("click", () => this.scrollBreadcrumbsLeft());
        $rightArrow.on("mouseenter", () => {
            rightActivityTimer = setTimeout(() => {
                this.scrollBreadcrumbsRight();
            }, 200);
        });
        $leftArrow.on("mouseenter", () => {
            leftActivityTimer = setTimeout(() => {
                this.scrollBreadcrumbsLeft();
            }, 200);
        });
        $rightArrow.on("mouseleave", () => {
            clearTimeout(rightActivityTimer);
        });
        $leftArrow.on("mouseleave", () => {
            clearTimeout(leftActivityTimer);
        });
    }

    private scrollBreadcrumbsRight() {
        const $breadcrumb = this.$(dom.BROWSE_BREADCRUMB);
        const $breadcrumbContainer = this.$(dom.BROWSE_BREADCRUMB_CONTAINER);

        this.setBreadcrumbScrollArrows(true);

        const breadcrumbWidth = $breadcrumb.width() + breadcrumbMargin + breadcrumbPadding;
        const searchButtonWidth = this.$(dom.BROWSE_SEARCH).outerWidth() + searchButtonPadding;
        const clearButtonWidth = this.$(dom.BROWSE_CLEAR).outerWidth() + clearButtonPadding;
        const scrollDistance = breadcrumbWidth - this.$el.width() + searchButtonWidth + clearButtonWidth;

        $breadcrumb.animate({left: -scrollDistance + "px"});
    }

    private scrollBreadcrumbsLeft() {
        const $breadcrumb = this.$(dom.BROWSE_BREADCRUMB);

        this.setBreadcrumbScrollArrows(false);

        $breadcrumb.animate({left: 0 + "px"});
    }

    private setBreadcrumbScrollArrows(activateLeft: boolean) {
        const $rightArrow = this.$(dom.BROWSE_BREADCRUMB_SCROLL_RIGHT);
        const $leftArrow = this.$(dom.BROWSE_BREADCRUMB_SCROLL_LEFT);

        if (activateLeft) {
            $leftArrow.fadeIn();
            $rightArrow.fadeOut();
        } else {
            $leftArrow.fadeOut();
            $rightArrow.fadeIn();
        }
    }

    private browseScrollLeft() {
        this.model.PanelsShiftValue += this.model.PanelWidth;
    }

    private browseScrollRight() {
        this.model.PanelsShiftValue -= this.model.PanelWidth;
    }

    private panelsShiftValueChanged() {
        this.$(dom.BROWSE_PANELS).animate({left: this.model.PanelsShiftValue});

        this.setLeftPanelScrollerVisibility();
        this.setRightPanelScrollerVisibility();
    }

    private setLeftPanelScrollerVisibility() {
        if (this.model.Panels.size() > this.model.MaxPanels && this.model.PanelsShiftValue < 0) {
            this.$(dom.BROWSE_SCROLL_LEFT).show();
        } else {
            this.$(dom.BROWSE_SCROLL_LEFT).hide();
        }
    }

    private setRightPanelScrollerVisibility() {
        if (this.model.Panels.size() > this.model.MaxPanels && this.model.PanelsShiftValue > ((this.model.MaxPanels - this.model.Panels.size()) * this.model.PanelWidth)) {
            this.$(dom.BROWSE_SCROLL_RIGHT).show();
        } else {
            this.$(dom.BROWSE_SCROLL_RIGHT).hide();
        }
    }

    private setMaxPanels() {
        const viewPadding = 15;
        this.model.MaxPanels = Math.floor((this.$el.width() - viewPadding) / this.model.PanelWidth);
        this.model.setPanelShift();
    }

    private hideBreadcrumbScrollers() {
        const $rightArrow = this.$(dom.BROWSE_BREADCRUMB_SCROLL_RIGHT);
        const $leftArrow = this.$(dom.BROWSE_BREADCRUMB_SCROLL_LEFT);

        $rightArrow.hide();
        $leftArrow.hide();
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/old-browse/views/browse.ts